
export default class Passenger{
    child=0;
    infant=0;
    adult=1;
};